import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AuthService } from '../../../../../shared/services/auth.service';
import { DocumentService } from '../../services/document.service';
import { IUser } from '../../../../../shared/models/user';
import { filter, Subscription, switchMap, take, takeWhile } from 'rxjs';
import { UserUtility } from '../../../../../shared/utilities/user-utility';
import { FileDownloadUtility } from '../../../../../shared/utilities/blob-download-utility';

@Component({
    selector: 'app-sa-library-download',
    templateUrl: './sa-library-download.component.html',
    styleUrl: './sa-library-download.component.scss',
    standalone: false
})
export class SaLibraryDownloadComponent implements OnInit, OnDestroy, OnChanges {

  @Input() uri: string = '';
  @Input() index: number | null = null;
  @Input() fromDocumentSearch: boolean = true;
  isDownloadButtonVisible: boolean = false;
  isDownloadButtonEnabled: boolean = false;
  currentUser: IUser | null = null;
  subscriptions: Subscription = new Subscription();
  
  constructor(
    private _authService: AuthService,
    private _documentService: DocumentService) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['uri'] && changes['uri'].currentValue && !changes["uri"].firstChange) {
      this.uri = changes['uri'].currentValue;
      this.initialiseSubscriptions();
    }
  }

  ngOnInit(): void {

    const userSubscription = this._authService.currentUserSubject
    .pipe(
      filter(user => !!user),
      take(1)
    )
    .subscribe({
      next: (user: IUser | null) => {
        this.currentUser = user;
        this.initialiseSubscriptions();
      }
    });
    this.subscriptions.add(userSubscription);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  initialiseSubscriptions(): void {
    if(!this.uri || !this.currentUser) {
      this.setValues(false);
      return;
    }

    const canDownloadSubscription = this._documentService.canDownloadDocument(this.uri)
    .subscribe({
      next: (response) => {
        if (response.success && this.currentUser) {
          this.setValues(response.content);
        } else {
          console.error(`Error checking download permission: ${response.message}`);
        }
      }
    });

    this.subscriptions.add(canDownloadSubscription);
  }

  setValues(canDownloadDocument: boolean) {
    this.isDownloadButtonEnabled = canDownloadDocument;

    this.isDownloadButtonVisible = canDownloadDocument || UserUtility.isCommitteeMember(this.currentUser);
  }

  onDownloadClick(e: MouseEvent) {
    e.stopPropagation();
    const uri = this.uri;
    
    if (!uri) {
      console.log('No URI found for document.');
      return;
    }

    const fileName = uri + '.pdf';

    this.subscriptions.add(this._documentService.downloadDocument(uri).subscribe(response => {
      if (response.success) {
        FileDownloadUtility.downloadbase64StringToBrowser(response.content, fileName);
      } else {
        console.log(`Download failed. ${response.message}`);
      }
    }));
  }
}
